/**
 * ScrollTo
 *
 * @since 1.0.0
 */

import Smooth from 'smoothscroll'

const ScrollTo = () => {
  const links = document.querySelectorAll('.js-scroll-to')
  const top = document.querySelector('.js-scroll-top-target')
  const backTop = document.querySelector('.js-back-to-top')
  const backLinks = document.querySelectorAll('.js-scroll-top')
  const navLinks = document.querySelectorAll('.js-scroll-nav')
  if (links) {
    [].forEach.call(links, link => {
      link.addEventListener('click', function (e) {
        e.preventDefault()
        let target = document.getElementById(link.dataset.target)
        Smooth(target)
      })
    })
  }
  if (backLinks) {
    [].forEach.call(backLinks, link => {
      link.addEventListener('click', function (e) {
        e.preventDefault()
        Smooth(top)
      })
    })
  }
  if (backTop) {
    backTop.addEventListener('click', (e) => {
      Smooth(0)
    })
  }
  if (navLinks.length) {
    ;[...navLinks].forEach(link => {
      const { href } = link
      link.addEventListener('click', (e) => {
        if (hasHash(href)) {
          console.log(hasHash(href))
          const id = href.split('#').pop()
          Smooth(document.getElementById(id))
        }
      })
    })
  }

  const hasHash = (link) => {
    if (link.indexOf('#') !== -1) {
      return true
    }
  }
}

export default ScrollTo



// WEBPACK FOOTER //
// ./src/js/modules/ScrollTo.js